import type { PensionFeatureConfig } from '../types/PensionFeatureConfig';

export const pension: PensionFeatureConfig = {
    defaultRoute: 'details',
    relyOnWebAPIAlias: true,
    overview: {
        visible: false,
        highlights: {
            showOwnerContribution: false,
            showContractEndDate: false,
        },
        highlightedDetails: {
            showAdhesionAct: false,
            showContractNumber: false,
        },
        learnMore: {
            visible: false,
            savingsUrl: null,
            supplementaryUrl: null,
            phone: null,
            email: null,
        },
    },
    transactions: {
        visible: true,
    },
    funds: {
        visible: false,
    },
};
